import { CLARITY_PROJECT_ID } from '../data/analytics'

declare global {
  interface Window {
    clarity?: ((...args: unknown[]) => void) & { q?: unknown[] }
  }
}

/**
 * Injects the Microsoft Clarity tag once. Does nothing until a project ID
 * is configured in data/analytics.ts.
 */
export function initClarity(): void {
  if (!CLARITY_PROJECT_ID) return
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (window.clarity) return

  /* eslint-disable */
  ;(function (c: any, l: any, a: any, r: any, i: any, t?: any, y?: any) {
    c[a] =
      c[a] ||
      function () {
        ;(c[a].q = c[a].q || []).push(arguments)
      }
    t = l.createElement(r)
    t.async = 1
    t.src = 'https://www.clarity.ms/tag/' + i
    y = l.getElementsByTagName(r)[0]
    if (y && y.parentNode) {
      y.parentNode.insertBefore(t, y)
    } else {
      ;(l.head || l.body || l.documentElement).appendChild(t)
    }
  })(window, document, 'clarity', 'script', CLARITY_PROJECT_ID)
  /* eslint-enable */
}
